// extracted by mini-css-extract-plugin
export default {"Footer":"ConflictsModal_Footer__z2hjy","Button":"ConflictsModal_Button__8xcCv","Alert":"ConflictsModal_Alert__FTVsm"};